import React, { Component } from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledSelect = styled(ReactSelect)`
  .Select-value-label, .Select-option {
    color: ${props => css`${props.styled && props.styled.color} !important`}
  }
}`;

/**
 * A pure dump Select component.
 */
export default class SelectV2 extends Component {
  value() {
    return this.props.options.find(option => option.value == this.value)
  }

  render() {
    const {
      value,
      onChange,
      selectedValue,
    } = this.props;
    return (
      <StyledSelect
        {...this.props}
        options={this.value()}
        onChange={onChange}
        value={selectedValue}
        id={`split-button-basic-${0}`}
        onResetToPrev={this.onResetToPrev}
        />
    );
  }
}

SelectV2.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(Object),
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  selectedValue: PropTypes.object,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};
